/**
 * Starts a download of a presigned (attachment) URL in the current tab. Unlike `window.open` after an
 * `await`, an in-page anchor click is not treated as a popup, so Safari, iOS and in-app browsers
 * (Facebook Messenger) do not block it; the storage response's `Content-Disposition: attachment`
 * keeps the page where it is.
 */
export function startDownload(url: string): void {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.rel = "noopener noreferrer";
  anchor.download = "";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}
